<div class="w-full max-w-full plant-details grid">
  <div
    class="w-full sm:gap-2 lg:gap-3 flex max-w-full plant-detail overflow-x-auto sm:pb-4 lg:py-0 lg:m-0"
  >
    @for (item of headerData; track $index) {
      <div
        class="bg-[#252A30] flex box sm:w-[300px] sm:min-w-[300px] lg:min-w-unset lg:py-2 xl:py-0 xl:px-0 xl:h-[6dvh] lg:h-[7dvh] lg:w-[19.7%] lg:m-unset justify-between items-center sm:p-[0.5%] xl:p-[0.6%] rounded-full text-white lg:p-[0.3%]"
      >
        <div class="flex items-center h-full">
          <div class="ml-3">
            @if (item.overlayIcon) {
              <div class="outer-container">
                <img
                  src="{{ item.icon }}"
                  alt=""
                  class="outer-image lg:h-9 lg:w-9 h-8 w-8"
                />
                <div class="inner-container">
                  <img
                    src="{{ item.overlayIcon }}"
                    alt="Icon"
                    class="inner-image lg:h-6 lg:w-6 h-5 w-5"
                  />
                </div>
                <div class="inner-text">
                  <span class="lg:text-[8px] md:text-[6px] text-[5px] mr-1">{{
                    item.overlayString
                  }}</span>
                </div>
              </div>
            } @else {
              <div class="h-full flex items-center">
                <img
                  src="{{ item.icon }}"
                  alt=""
                  class="lg:h-9 lg:w-9 h-8 w-8"
                />
              </div>
            }
          </div>
          <div class="lg:ml-4 md:ml-3 ml-2">
            <span class="text-base text-[#94989E]">{{ item.description }}</span>
          </div>
        </div>
        <div class="mr-5">
          <span class="text-xl font-medium">{{ item.value }}</span>
        </div>
      </div>
    }
  </div>
</div>
